<template>
  <div
    class="campaign-section__holder"
    :class="widgetHolderClass"
  >
    <div class="campaign-section__header">
      <div
        class="campaign-section__header_content"
      >
        <div class="campaign-section__header_title">
          <span
            class="campaign-section__heading_title"
            :class="widgetTitleCustomClass"
          >
            {{ widgetTitle }}
          </span>
          <slot
            name="titleExtra"
          />
        </div>
        <div 
          class="campaign-section__header_right_content"
        >
          <slot
            name="headerExtra"
          >
            <a
              href="javascript:;"
              class="btn btn-list-function pull-right panel-collpase-toggle-btn "
              @click="onShowContentsClick"
            >
              <i
                class="typcn"
                :class="{'typcn-arrow-sorted-up': showContent, 'typcn-arrow-sorted-down': !showContent}"
                aria-hidden="true"
              />
            </a>
          </slot>
        </div>
      </div>
    </div>
    <div
      v-show="showContent"
      class="campaign-section__content"
    >
      <slot 
        name="content"
      />
      <div class="clearfix" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    headerCollapse: {
      type: Boolean,
      default: false,
    },
    showContent: {
      type: Boolean,
      default: false,
    },
    widgetTitle: {
      type: String,
      default: 'Title'
    },
    widgetHolderClass: {
      type: String,
      default: ''
    },
    widgetTitleCustomClass: {
      type: String,
      default: ''
    },
  },
  methods: {
    onShowContentsClick() {
      this.$emit('onShowContentsClick');
    }
  },
};
</script>